import { createElement } from 'react';
import type { ReactElement } from 'react';
import type { IconNode } from '@source-components-react/types';

/**
 * Turns persisted Lucide geometry into SVG children.
 *
 * Shared so `r-icon` and any component that embeds an icon draw from one
 * implementation — the icon architecture's rule that there is exactly one
 * icon path, whoever is rendering it. The caller owns the `<svg>` element,
 * because a standalone icon and an icon inside a button want different
 * sizing and accessibility defaults.
 */
export const renderIconChildren = (iconNode: IconNode): ReactElement[] =>
  iconNode.map(([tag, attributes], index) =>
    createElement(tag, { ...attributes, key: attributes.key ?? `${tag}-${index}` })
  );
